<template>
  <div class="winning-list-notice-bar">
    <ym-swipe class="winning-list-notice-bar-list"
              :options="swiperOption"
              ref="swiper"
    >
      <ym-swipe-slide class="winning-list-notice-bar-list-item swiper-no-swiping"
                      v-for="(item, index) in list"
                      :key="index"
      >
        <span class="winning-list-notice-bar-list-item-text ym-line-ellipsis"
              v-html="`${item.name}开出了${item.prize.title}`"
        ></span>
      </ym-swipe-slide>
    </ym-swipe>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  export default {
    name: 'WinningListNoticeBar',
    components: {
      'ym-swipe': swiper,
      'ym-swipe-slide': swiperSlide,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        swiperOption: {
          direction: 'vertical',
          loop: true,
          autoplay: {
            delay: 3000,
          },
        },
      };
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .winning-list-notice-bar {
    box-sizing: border-box;
    width: 560px;
    height: 68px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 34px;
    border: 1px solid @color-white;
    &-list {
      height: 68px;
      margin: 0;
    }
    &-list-item {
      width: 560px;
      height: 68px;
      color: @color-white;
      font-size: @font-size-base;
      text-align: center;
      line-height: 68px;
    }
  }
</style>
